export class StatementFileInfoModel
{
	public Id: string = '';
	public FileTypeId: string = '';
	public FileName: string = '';
    public PageCount:number = 0;
	public FileSize: number = 0;
	public FileHash: string = '';
}
